import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { eventBus } from 'src/services/EventBus/eventBus';
import type { AxiosCustomHttpError } from './axios';

declare module '@tanstack/react-query' {
  export interface MutationMeta extends Record<string, unknown> {
    httpErrors?: AxiosCustomHttpError;
  }

  export interface QueryMeta extends Record<string, unknown> {
    httpErrors?: AxiosCustomHttpError;
  }
}

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError(error, _variables, _context, mutation) {
      eventBus.getState().dispatch({
        type: 'ReactQueryError',
        error,
        errors: mutation.meta?.httpErrors,
      });
    },
  }),
  queryCache: new QueryCache({
    onError(error, query) {
      eventBus.getState().dispatch({
        type: 'ReactQueryError',
        error,
        errors: query.meta?.httpErrors,
      });
    },
  }),
});

export const queryRetry = (_count: number, error: AxiosError) => {
  try {
    const errorCode = error.response?.status;
    return !(errorCode === 403 || errorCode === 401);
  } catch (_error) {
    return true;
  }
};

export enum QueryKey {
  MEET = 'meet',
  DRIVE = 'drive',
  SUBSCRIPTION = 'subscription',
  PLANS = 'plans',
  TODOGROUP = 'todogroup',
  TODO = 'todo',
  TAGS = 'tags',
  DOCS = 'docs',
  DOC = 'doc',
  TEAM = 'team',
  ROLES = 'roles',
  NOTIFICATIONS = 'notifications',
  AI_CHATS = 'ai_chats',
  AI_SCHEDULES = 'ai_schedules',
  CALENDAR = 'calendar',
  CHAT = 'chat',
  GATHERING = 'gathering',
  SEARCH = 'search',
  DOCS_AI = 'docs_ai',
  BOARD_TEMPLATES = 'board_templates',
  SOUNDBOARD = 'soundboard',
  SECURITY_INFO = 'security_info',
  WORKSPACE_INVITE = 'workspace_invite',
  USER_SECURITY_EMAILS = 'user_security_emails',
  SUPPORT = 'support',
}
